import {filter, map, takeUntil} from "rxjs"
import {Box2, Vector2, Vector2Like} from "@cm/math"
import {CanvasComponent} from "@common/components/canvas/canvas/canvas.component"
import {CanvasToolboxItemBase} from "@common/helpers/canvas/canvas-toolbox/canvas-toolbox-item-base"
import {CanvasPhysicalInfo} from "@common/components/canvas"
import {CanvasToolboxItem} from "@common/helpers/canvas/canvas-toolbox/canvas-toolbox-item"

export class CanvasToolboxRootItem extends CanvasToolboxItemBase<null> {
    constructor(canvas: CanvasComponent) {
        super(null)
        this.init({
            canvasBoundsChange: canvas.canvasBoundsChanged$.pipe(
                takeUntil(this.unsubscribe),
                map((canvasBounds) => Box2.fromSize(canvasBounds)),
            ),
            viewChange: canvas.viewTransformChanged$.pipe(takeUntil(this.unsubscribe)),
            physicalInfoChange: canvas.pixelsPerCmChanged$.pipe(
                takeUntil(this.unsubscribe),
                map((pixelsPerCm) => ({pixelsPerCm, originXCm: 0, originYCm: 0})),
            ),
            get zoomLevel(): number {
                return canvas.$viewZoomLevel()
            },
            get canvasCursorPosition(): Vector2 {
                return Vector2.fromVector2Like(canvas.$cursorPositionPx())
            },
            get canvasBounds(): Box2 {
                return Box2.fromSize(canvas.$canvasBounds())
            },
            get physicalInfo(): CanvasPhysicalInfo | undefined {
                return {pixelsPerCm: canvas.$pixelsPerCm(), originXCm: 0, originYCm: 0}
            },
            addChildItem: (_item: CanvasToolboxItem) => {},
            sendItemToBack: (_item: CanvasToolboxItem) => {},
            bringItemToFront: (_item: CanvasToolboxItem) => {},
            isPointInImage: (point: Vector2Like) => !this.imageIsConfinedToCanvas || canvas.containsPoint(point),
            activatePaperScope: () => canvas.beginPaperCreation(),
            addShortcut: (keys: string[]) =>
                canvas.hotkeys.addShortcut(keys).pipe(
                    takeUntil(this.unsubscribe),
                    filter(() => this.visible && !this.disabled),
                ),
        })
    }

    get imageIsConfinedToCanvas(): boolean {
        return true
    }
}
